import { User } from 'src/app/components/models/user.mode';
import { Asset } from 'src/app/components/models/asset.model';
import { QuoteModel } from 'src/app/components/models/quote.model';
import { GetTxInfoResult } from 'src/app/components/models/get-tx-info-result.model';
import { PaymentRequestModel } from 'src/app/components/models/payment.request.model';
import { PaymentQueryParams, PaymentRouteParams } from './../../../shared/models/payment-params.model';
import { FormControl } from '@angular/forms';

export interface PaymentForm {
  amount: FormControl<string>;
  targetAmount: FormControl<string>;
  reference: FormControl<string>;
  transactionID: FormControl<string>;
  assetId?: FormControl<string>;
}

export interface CryptoAddressResult {
  nick: string | null;
  user: User;
  cryptoAddress: CryptoAddress;
}

export interface CryptoAddress {
  address: string | null;
  memo: string | null;
  blockchainAsset: BlockchainAsset;
  cryptoDataSource: CryptoDataSource;
  cryptoConnectionId: string | null;
  cryptoAddressUsageLogId: string | null;
}

export interface BlockchainAsset {
  id: string | null;
  assetChain: string | null;
  assetTicker: string | null;
}

export enum CryptoDataSource {
  None = 'None',
  Manual = 'Manual',
  Foxbit = 'Foxbit',
  KyrrexDirect = 'KyrrexDirect',
  Kraken = 'Kraken',
  ManualWallet = 'ManualWallet',
  Coinbase = 'Coinbase',
}

export interface PaymentDetails {
  reference?: string;
  payerName?: string;
  company?: string;
  email?: string;
  settlementAsset?: Asset;
  settlementAmount?: number;
  payingAsset?: Asset;
  paymentAmount?: number;
  assetValue?: string;
  transactionId?: string;
  quote?: QuoteModel;
  rates?: QuoteModel;
  convertedAmount?: number;
  network?: string;
  selectedReceiverWallet?: CryptoAddressResult;
  shouldKeepQuote?: boolean;
}

export interface AmountInfo {
  payingAssetPrice?: number;
  assetConversionRateAmount?: number;
  targetCurrencyQuote?: number | string;
}

export interface PaymentState {
  payerIsAuthenticated: boolean;
  currentStep: string;
  stepsCompleted: { [key: string]: boolean };
  paymentDetails: PaymentDetails;
  amountInfo: AmountInfo;
  paymentRequest: PaymentRequestModel;
  receiverAcceptedAssets: Asset[];
  receiverConnections: Asset[];
  user?: User;
  targetUser?: User;
  txInfo?: GetTxInfoResult;
  paymentQueryParams: PaymentQueryParams;
  paymentParams?: PaymentRouteParams;
  resumePayment: boolean;
  noWallet: boolean;
}

export const initialState: PaymentState = {
  payerIsAuthenticated: false,
  currentStep: 'overview',
  stepsCompleted: {
    overview: false,
    identification: false,
    payment: false,
    confirmation: false,
  },
  receiverAcceptedAssets: [] as Asset[],
  receiverConnections: [] as Asset[],
  amountInfo: {} as AmountInfo,
  paymentRequest: {} as PaymentRequestModel,
  paymentDetails: {} as PaymentDetails,
  user: {} as User,
  targetUser: {} as User,
  txInfo: {} as GetTxInfoResult,
  paymentQueryParams: {} as PaymentQueryParams,
  paymentParams: {} as PaymentRouteParams,
  resumePayment: false,
  noWallet: false,
};
